module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/evvnt_ticketing-0f619499a5ebdc075355b1f56af0f946.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/evvnt_ticketing.png
// module id = 1456
// module chunks = 0